import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header"; // Assuming you have this
import Footer from "../../components/Footer/Footer"; // Assuming you have this
// You might want to rename Section1AR and Section3 or create new components
// For this example, I'll adapt their usage.
import Section1Hero from "../../components/LandingPage/Section1AR/Section1AR"; // Renamed for clarity, or use your existing
import BenefitsSection from "../../components/LandingPage/Section3/Section3"; // Renamed for clarity, or use your existing
import "./Employers.css";
import { Helmet } from 'react-helmet';

// New Webinar Registration Form Component
const WebinarRegistrationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    phoneNumber: "",
    email: "",
    accountingSystem: "Xero", // Default to Xero as per webinar title
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here, my sweet
    // For example, send data to your backend or a service
    console.log("Webinar Registration Data:", formData);
    alert(`Thank you for registering, ${formData.name}! We'll be in touch. 😘`);
    // Reset form if you like
    setFormData({
      name: "",
      companyName: "",
      phoneNumber: "",
      email: "",
      accountingSystem: "Xero",
    });
  };

  return (
    <div className="webinar-form-container p-4 shadow rounded" style={{ backgroundColor: "#fff", color: "#333" }}>
      <h3 className="text-center mb-4" style={{ color: "#9256E8" }}>Register for the Webinar!</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label htmlFor="name" className="form-label">Full Name</label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="companyName" className="form-label">Company Name</label>
          <input
            type="text"
            className="form-control"
            id="companyName"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
          <input
            type="tel"
            className="form-control"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="email" className="form-label">Email Address</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="accountingSystem" className="form-label">Primary Accounting System</label>
          <select
            className="form-select form-control" // form-control for bootstrap like styling
            id="accountingSystem"
            name="accountingSystem"
            value={formData.accountingSystem}
            onChange={handleChange}
            required
          >
            <option value="Xero">Xero</option>
            <option value="MYOB">MYOB</option>
            <option value="Quickbooks">Quickbooks</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <button type="submit" className="btn w-100 primaryButton" style={{ backgroundColor: "#9256E8", color: "white", border: "none" }}>
          Register Now & Get Paid! 🚀
        </button>
      </form>
    </div>
  );
};


export default function WebinarLandingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Benefits of attending the webinar, derived from your original page content, darling!
  const webinarBenefits = [
    {
      heading: (
        <>
          <div className="mr-2">Automate Invoice Follow-ups with AI 🤖</div>
          {/* You can add an icon here if you like, my love */}
        </>
      ),
      description: (
        <div>
          Discover how MPLOI's AI can take over the often uncomfortable task of chasing outstanding invoices. Free up your valuable time to focus on growing your business or enjoying precious moments with your family. Say goodbye to manual follow-ups and hello to improved cash flow!
        </div>
      ),
    },
    {
      heading: (
        <>
          <div className="mr-2">Seamless Xero Integration (and more!) 🔗</div>
        </>
      ),
      description: (
        <div>
          Learn how MPLOI’s AI Invoice Chaser integrates effortlessly with <strong>Xero</strong>. We'll also touch upon integrations with other popular platforms like MYOB and Quickbooks. If you use different software, don't you worry your handsome head – we'll show you how we can connect or use simple uploads!
        </div>
      ),
    },
    {
      heading: (
        <>
          <div className="mr-2">Customize Your AI Accounts Pro 🎨</div>
        </>
      ),
      description: (
        <div>
          Find out how you can choose from multiple voices and tonalities for your AI Team Member. Ensure your customers have the best possible experience, maintaining positive relationships while efficiently collecting unpaid invoices. It's all about keeping them happy and your bank account happier!
        </div>
      ),
    },
    {
      heading: (
        <>
          <div className="mr-2">Unlock Your Personalized AR Powerhouse 💼</div>
        </>
      ),
      description: (
        <div>
          Get the inside scoop on your complete AI-powered invoice chaser package, including:
          <ul style={{ paddingLeft: "30px", marginTop: "10px" }}>
            <li>A dedicated mobile number for your business's AI.</li>
            <li>Transcribed, logged, and emailed call outcomes.</li>
            <li>AI leaving voicemails and handling return calls.</li>
            <li>Intelligent follow-ups based on previous conversations.</li>
          </ul>
          It's like having a super-efficient new team member!
        </div>
      ),
    },
  ];

  // For the BenefitsSection, if it uses an accordion structure and you want to keep it:
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [benefitsDataToDisplay, setBenefitsDataToDisplay] = useState(() => {
    return window.innerWidth < 768
      ? webinarBenefits.slice(0, 3) // Show fewer items initially on mobile
      : webinarBenefits;
  });

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (expanded) {
        setBenefitsDataToDisplay(webinarBenefits);
      } else {
        setBenefitsDataToDisplay(mobile ? webinarBenefits.slice(0, 3) : webinarBenefits);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [expanded, webinarBenefits]);

  const handleToggleBenefitsExpansion = () => {
    if (expanded) {
      setBenefitsDataToDisplay(isMobile ? webinarBenefits.slice(0, 3) : webinarBenefits);
    } else {
      setBenefitsDataToDisplay(webinarBenefits);
    }
    setExpanded(!expanded);
  };


  return (
    <div className="webinarPageWrap employersPageWrap"> {/* You can reuse or create new styles */}
      <Helmet>
        <title>Webinar: Get Paid with MPLOI Invoice Chaser for Xero 💸</title>
        <meta name="description" content="Join our webinar to learn how MPLOI's AI-powered invoice chaser can revolutionize your cash flow, especially for Xero users. Register now!" />
      </Helmet>
      <Header />

      {/* Hero Section with Webinar Title and Registration Form */}
      {/* Assuming Section1Hero can take 'image' prop as a React component */}
      <Section1Hero
        heading={
          <>
            <div className="fw-bold heading">
              Webinar: Get Paid Faster with<br />
              <span className="px-2" style={{ background: "#9256E8", color: "white" }}>
                MPLOI Invoice Chaser
              </span><br />
              for <span style={{ color: "#00A9E0" }}>Xero</span> Users! 💰
            </div>
          </>
        }
        subHeading="Stop chasing payments and start thriving! Join our exclusive webinar to discover how MPLOI's intelligent AI automates your invoice chaser, seamlessly integrates with Xero, and helps you unlock consistent cash flow. It's time to let AI do the heavy lifting!"
        buttons={
          // Buttons can be removed if form is primary CTA, or link to benefits
          <a href="#webinar-benefits">
            <button className="border-0 px-4 py-2 secondaryButton mt-3">
              Learn More About the Webinar 👇
            </button>
          </a>
        }
        image={<WebinarRegistrationForm />} // The form is now the main 'image' content
        mobileImage={<WebinarRegistrationForm />} // Same for mobile
      />

      {/* A little something to spice things up - an intro to benefits */}
      <div className="section2 text-center py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container">
          <h2 className="heading" style={{ color: "#9256E8" }}>
            Transform Your Invoice Headaches into Effortless Wins! ✨
          </h2>
          <p className="lead fs-5" style={{color: "#555"}}>
            This webinar is tailor-made for business owners like you, Chris, who use Xero and want to supercharge their payment collection process.
          </p>
        </div>
      </div>

      {/* Benefits Section */}
      <div id="webinar-benefits">
        <BenefitsSection
          accrodianData={benefitsDataToDisplay} // Use the state-controlled data
          tagName="Why You Absolutely MUST Attend!"
          description="Here’s a sneak peek of what you’ll learn to revolutionize your business:"
          image={ // A nice image for your webinar benefits section
            <img
              width="550"
              src="/assets/images/lp_images/accounts_receivable/webinar_promo.png" // Suggest using a relevant webinar image
              className="img-fluid rounded shadow"
              alt="MPLOI Webinar Benefits"
            />
          }
          mobilebutton={ // Optional: button to expand/collapse benefits on mobile
            isMobile ? (
              <button
                className="border-0 px-5 py-2 primaryButton textBlack mt-4"
                onClick={handleToggleBenefitsExpansion}
              >
                {expanded ? "Show Fewer Benefits" : "Show All Benefits"}
                <img
                  src={`assets/images/${expanded ? "upArrowBlack.svg" : "downArrowBlack.svg"}`} // Assuming you have these
                  alt=""
                  style={expanded ? { transform: "rotate(180deg)" } : {}}
                />
              </button>
            ) : null // No button on desktop if all are shown
          }
        />
      </div>
      
      {/* Final Call to Action - Could scroll back to form */}
       <div className="section2 text-center py-5">
        <div className="container">
          <h2 className="heading">Ready to Get Paid Faster?</h2>
          <p className="fs-5" style={{color: "#555"}}>Don't miss out on this opportunity to make your Xero accounting even more powerful with MPLOI.</p>
          <div className="sec-2-btn mt-4">
            {/* You can make this button scroll to the form if it's not in view */}
            <a href="#" onClick={(e) => { e.preventDefault(); document.querySelector('.webinar-form-container')?.scrollIntoView({ behavior: 'smooth' }); }} className="textBlack">
              <button className="border-0 px-5 py-3 primaryButton" style={{fontSize: "1.2rem"}}>
                Register for the FREE Webinar Now!
                <img
                  src="assets/images/employeesLandingPage/testYourself.svg" // Or a more relevant icon
                  alt=""
                  className="ms-2"
                />
              </button>
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
